module.exports = __webpack_public_path__ + "static/media/blackDiscord.c00c3924.svg";